import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import { Tile as TileProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/common/tile';
import Enum from '@square/dashboard-utilities/utils/enum';
import { computed } from '@ember/object';
export const TileAppearance = new Enum(Object.keys(TileProto.TileAppearance));
export default ProtoBaseModel.extend({
  tileAppearance: attr(TileAppearance, {
    defaultValue: TileAppearance.IMAGE
  }),
  displayValueTranslationKey: computed('tileAppearance', function () {
    return this.tileAppearance === TileAppearance.IMAGE ? 'business.devices.profiles.v2.settings.checkout.tile.tileAppearance.image.displayValue' : 'business.devices.profiles.v2.settings.checkout.tile.tileAppearance.text.displayValue';
  })
});